// Single source of truth for the phone breakpoint. Matches Backstage's own
// SidebarPage, which switches to mobile at MUI's `down('xs')` (max-width 599.95px),
// so the nav, layout, and content frame all pivot on the same line and can't drift.
export const MOBILE_MEDIA_QUERY = '(max-width:599.95px)';
